import React from 'react';
import { AppBar, Container, Toolbar, Box, Button, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

const Headers = ({ handleDrawerToggle }) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'white',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar>
          {/* Logo Section */}
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
            }}
          >
              <Link to="/droneshalaa" style={{ textDecoration: 'none' }}>

            <img
              src={require('../../assets/image/png/Drone Shala.png')}
              alt="Droneshala Logo"
              style={{
                height: '40px',
                width: 'auto',
                transition: 'transform 0.3s ease',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
              onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            />
            </Link>
          </Box>

          {/* Mobile Menu Icon */}
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            sx={{
              display: { xs: 'block', md: 'none' },
              color: 'black',
            }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon sx={{ fontSize: '30px' }} />
          </IconButton>

          {/* Desktop Navigation Links */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 4,
              flexGrow: 2,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
             <Link to="/droneshalaa" style={{ textDecoration: 'none' }}>
            <Button
              sx={{
                color: 'black',
                fontWeight: '600',
                textTransform: 'none',
                fontSize: '16px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.05)',
                },
              }}
            >
              Home 
            </Button>
            </Link>
            <Link to="/E-library" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  color: 'black',
                  fontWeight: '600',
                  textTransform: 'none',
                  fontSize: '16px',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                  },
                }}
              >
                E-Library
              </Button>
            </Link>
            <Link to="/training-courses/0" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  color: 'black',
                  fontWeight: '600',
                  textTransform: 'none',
                  fontSize: '16px',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                  },
                }}
              >
                Courses
              </Button>
            </Link>
          </Box>

          {/* Desktop Login and Get Started */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 2,
              alignItems: 'center',
            }}
          >
            <Button
              sx={{
                color: 'black',
                fontWeight: '600',
                textTransform: 'none',
                fontSize: '16px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.05)',
                },
              }}
            >
              Login
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{
                color: 'white',
                fontWeight: '600',
                textTransform: 'none',
                fontSize: '16px',
                padding: '8px 20px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                  boxShadow: '0 6px 8px rgba(0, 0, 0, 0.15)',
                },
              }}
            >
              Get Started
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Headers;
